export default "__VITE_ASSET__e3b72676__"